"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFromLocalStorage = loadFromLocalStorage;
exports.removeLocalStorage = removeLocalStorage;
exports.saveToLocalStorage = saveToLocalStorage;
exports.storageLocal = storageLocal;
var _log = require("../utils/log");
// key needed for log functionality used if appName is not provided
const storageKey = 'storageLocal';

/**
 * Function will return parsed serialized data from local storage based on name
 * In case there is no data or data is null/undefined, fallback value will be returned.
 * In case of error, error is written to console and fallback value is returned.
 * @param name Local storage name
 * @param fallback Value in case the local storage item is not defined or some error occurs
 * @param appName Application name / logger key
 * @returns Parsed, serialized value from local storage or fallback value
 */
function loadFromLocalStorage(name, fallback, appName) {
  try {
    const serializedData = localStorage.getItem(name);
    (0, _log.log)(appName ?? storageKey, 4, `📦 Local->load->${name} | fallback: ${JSON.stringify(fallback)} | serializedData: ${serializedData}`);
    let returnValue = fallback;
    if (serializedData) {
      returnValue = JSON.parse(serializedData);
    }
    return returnValue;
  } catch (error) {
    (0, _log.log)(appName ?? storageKey, 1, `📦 Local->load->${name}`, error);
    return fallback;
  }
}

/**
 * Function will stringify value and store it into the local storage with a key: name.
 * In case of error, error is written to console.
 * @param name Local storage name
 * @param value Value we want to store into local storage
 * @param appName Application name / logger key
 */
function saveToLocalStorage(name, value, appName) {
  try {
    (0, _log.log)(appName ?? storageKey, 4, `📦 Local->save->${name} | value: ${JSON.stringify(value)}`);
    let serializedData = '';
    serializedData = JSON.stringify(value);
    localStorage.setItem(name, serializedData);
  } catch (error) {
    (0, _log.log)(appName ?? storageKey, 1, `📦 Local->save->${name}`, error);
  }
}

/**
 * Function will remove record from the local storage based on name
 * In case of error, error is written to console.
 * @param name Local storage name
 * @param appName Application name / logger key
 */
function removeLocalStorage(name, appName) {
  try {
    (0, _log.log)(appName ?? storageKey, 4, `📦 Local->remove->${name}`);
    localStorage.removeItem(name);
  } catch (error) {
    (0, _log.log)(appName ?? storageKey, 1, `📦 Local->remove->${name}`, error);
  }
}

/**
 * Function will return functions for working with local storage
 * @param appName Application name / logger key
 * @returns Functions for working with local storage
 */
function storageLocal(appName) {
  return {
    loadLocal: (name, fallback) => loadFromLocalStorage(name, fallback, appName),
    saveLocal: (name, value) => saveToLocalStorage(name, value, appName),
    removeLocal: name => removeLocalStorage(name, appName)
  };
}
